// extracted by css-extract-rspack-plugin
export default {"root":"ToolBar_root__2L3JN","spacer":"ToolBar_spacer__WAKoi","resetSelectionFab":"ToolBar_resetSelectionFab__VsDXN"};